import Layout from '@comp/layout'
import SolutionMeta from '@comp/solution/solution-meta'
import SolutionHero from '@comp/solution/solution-hero'
import IntegrationCatalog from '@comp/integrations/integration-catalog'
import FinalCta from '@comp/home/final-cta'

export default function IntegrationsPage() {
  return (
    <Layout>
      <SolutionMeta
        title="Integrations catalog"
        description="Every Monofor integration (SAML, OIDC, OAuth 2, RADIUS, browser, and native), searchable by protocol or vendor. Each entry deep-links to its docs."
        path="/integrations"
      />
      <main className="bg-surface text-ink-primary">
        <SolutionHero
          eyebrow="Integrations"
          title={
            <>
              Every Monofor integration,
              <br />
              one searchable catalog.
            </>
          }
          body="Connect Monofor to AWS, Microsoft 365, Fortigate VPN, Jira, Zendesk, Splunk, and over fifty more, through SAML 2, OIDC, OAuth 2, RADIUS, or our custom REST connector. Each entry deep-links to the docs you need to wire it up."
          badges={[
            '55+ named integrations',
            'SAML / OIDC / OAuth / RADIUS',
            'Custom REST for the long tail',
          ]}
        />
        <IntegrationCatalog />
        <FinalCta />
      </main>
    </Layout>
  )
}
